const uuidv5 = require('uuid/v5');

export default function generateUUID() {
    return uuidv5('www.deja.fashion', uuidv5.DNS);
}


// WEBPACK FOOTER //
// ./src/common/uuid.js